var _jsxFileName = "/opt/atlassian/pipelines/agent/build/src/hooks/useLibrePractice.tsx";
import React from 'react';
import { useCallback } from 'react';
import { Stack, Text } from '@adc/parallax-component-library';
import { CLOSE_MODAL, SHOW_MODAL } from 'Reducers/modal/types';
import i18n from 'Utilities/i18n';
import { store } from 'Utilities/store';
import { acceptOrRejectPracticeInvitationService } from 'Services/libre_api';
import { addPracticeService, removePracticeService, validatePracticeService } from 'Services/libre_api';
const useLibrePractice = () => {
  const acceptOrRejectPracticeInvitation = useCallback(async (invitationID, action) => {
    try {
      const practiceConnection = await acceptOrRejectPracticeInvitationService({
        action,
        invitationID
      });
      if (practiceConnection) {
        return {
          practiceConnection
        };
      }
      return {};
    } catch (err) {
      const error = err;
      const errorCode = error.response?.data.code;
      return {
        errorCode
      };
    }
  }, []);
  const validatePractice = useCallback(async businessID => {
    try {
      const practiceBody = await validatePracticeService(businessID);
      return {
        practiceBody
      };
    } catch (err) {
      const error = err;
      const errorCode = error.response?.data.code;
      return {
        errorCode
      };
    }
  }, []);
  const addPractice = useCallback(async practiceID => {
    try {
      const practiceBody = await addPracticeService(practiceID);
      return {
        practiceBody
      };
    } catch (err) {
      const error = err;
      const errorCode = error.response?.data.code;
      return {
        errorCode
      };
    }
  }, []);
  const removePractice = useCallback(async practiceID => {
    return removePracticeService(practiceID);
  }, []);
  const showStopSharingModal = useCallback(onRemoveClick => {
    store.dispatch({
      type: SHOW_MODAL,
      modalProps: {
        buttonLayout: 'column',
        details: /*#__PURE__*/React.createElement(Stack, {
          __self: this,
          __source: {
            fileName: _jsxFileName,
            lineNumber: 100,
            columnNumber: 11
          }
        }, /*#__PURE__*/React.createElement(Text, {
          color: "$text.100",
          fontWeight: "$bodyBase.strong",
          fontSize: "$bodyBase.strong",
          testID: "StopSharingModal.title",
          marginBottom: "$4",
          __self: this,
          __source: {
            fileName: _jsxFileName,
            lineNumber: 101,
            columnNumber: 13
          }
        }, i18n.t('Global.modals.stopSharingPractice.title')), /*#__PURE__*/React.createElement(Text, {
          color: "$text.100",
          fontWeight: "$bodyBase.default",
          fontSize: "$bodyBase.default",
          testID: "StopSharingModal.body",
          __self: this,
          __source: {
            fileName: _jsxFileName,
            lineNumber: 110,
            columnNumber: 13
          }
        }, i18n.t('Global.modals.stopSharingPractice.body'))),
        primaryAction: {
          label: i18n.t('Global.modals.stopSharingPractice.title'),
          destructive: true,
          onPress: () => {
            store.dispatch({
              type: CLOSE_MODAL
            });
            onRemoveClick();
          }
        },
        secondaryAction: {
          label: i18n.t('Global.microcopy.common.cancel'),
          onPress: () => store.dispatch({
            type: CLOSE_MODAL
          })
        },
        testID: 'StopSharingModal'
      }
    });
  }, []);
  return {
    showStopSharingModal,
    validatePractice,
    acceptOrRejectPracticeInvitation,
    addPractice,
    removePractice
  };
};
export default useLibrePractice;